export enum VerifyPinTypes {
  QRCODE = '2',
  SCANCODE = '0',
}
